import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const vaxios = axios.create({ baseURL: API });
vaxios.interceptors.request.use((c) => {
  const t = localStorage.getItem("mpf_visitor");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

const Ctx = createContext(null);

export function VisitorProvider({ children }) {
  const [visitor, setVisitor] = useState(null);
  const [ready, setReady] = useState(false);
  const [favs, setFavs] = useState([]);
  const [authOpen, setAuthOpen] = useState(false);

  const load = useCallback(async () => {
    if (!localStorage.getItem("mpf_visitor")) { setReady(true); return; }
    try {
      const { data } = await vaxios.get("/visitor/me");
      setVisitor(data.visitor);
      setFavs(data.visitor.favorites || []);
    } catch {
      localStorage.removeItem("mpf_visitor");
      setVisitor(null);
    } finally {
      setReady(true);
    }
  }, []);
  useEffect(() => { load(); }, [load]);

  const register = async (payload) => {
    const { data } = await vaxios.post("/visitor/register", payload);
    localStorage.setItem("mpf_visitor", data.access_token);
    setVisitor(data.visitor); setFavs(data.visitor.favorites || []);
    return data.visitor;
  };
  const login = async (email, password) => {
    const { data } = await vaxios.post("/visitor/login", { email, password });
    localStorage.setItem("mpf_visitor", data.access_token);
    setVisitor(data.visitor); setFavs(data.visitor.favorites || []);
    return data.visitor;
  };
  const logout = () => { localStorage.removeItem("mpf_visitor"); setVisitor(null); setFavs([]); };
  const isFav = (slug) => favs.includes(slug);
  const toggleFav = async (slug) => {
    if (!visitor) { setAuthOpen(true); return false; }
    const was = favs.includes(slug);
    setFavs((f) => (was ? f.filter((s) => s !== slug) : [...f, slug]));
    try {
      if (was) await vaxios.delete(`/visitor/favorites/${slug}`);
      else await vaxios.post(`/visitor/favorites/${slug}`);
    } catch (e) {
      setFavs((f) => (was ? [...f, slug] : f.filter((s) => s !== slug)));
      toast.error(e?.response?.data?.detail || "Erreur");
    }
    return true;
  };

  return (
    <Ctx.Provider value={{ visitor, ready, favs, authOpen, setAuthOpen, register, login, logout, isFav, toggleFav, vaxios }}>
      {children}
    </Ctx.Provider>
  );
}

export const useVisitor = () => useContext(Ctx);
